import axios from "axios";

const getApiBaseUrl = () => {
  // In production, use the API URL from environment
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Fallback: construct from host and port
  const host = import.meta.env.VITE_API_HOST || "localhost";
  const port = import.meta.env.VITE_API_PORT || "3001";
  return `http://${host}:${port}/api`;
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000, // Increased timeout for AWS
  withCredentials: true, // Important for CORS with credentials
});

// Request interceptor to add auth token and handle CORS
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Only set Content-Type for non-FormData requests
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }
    config.headers["Accept"] = "application/json";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors and CORS issues
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle CORS errors
    if (error.code === "ERR_NETWORK" || error.message.includes("CORS")) {
      console.error("CORS Error:", error);
      console.log("API Base URL:", getApiBaseUrl());
    }

    if (
      error.response?.status === 404 &&
      !error.config?.skipNotFoundRedirect &&
      !window.location.pathname.includes("/not-found")
    ) {
      window.location.href = "/not-found";
      return Promise.reject(error);
    }

    // Don't redirect if we're already on login page or it's a login request
    if (
      error.response?.status === 401 &&
      !window.location.pathname.includes("/login") &&
      !error.config?.url?.includes("/auth/login")
    ) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
